import createImageIcon from './createImageIcon';
import path from './back-arrow.svg';

export default createImageIcon({displayName: 'ArrowBackIcon', path});



// WEBPACK FOOTER //
// ./src/common/components/icons/ArrowBackIcon.js